/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
let ChangesetFileUpload = (_class = class ChangesetFileUpload extends Component {
  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when upload is successful.
   */
  onSelected(file) {
    const files = this.args.changeset.get(this.args.payloadKey);
    const isFirstSelectedFile = Boolean(!files);
    if (isFirstSelectedFile) {
      this.args.changeset.set(this.args.payloadKey, [file]);
    } else {
      files.push(file);
      this.args.changeset.set(this.args.payloadKey, files);
    }
  }

  /**
   * Callback function which is given
   * to the File upload component.
   * Will be called within the component
   * when a file is deleted.
   */
  destroyFile(index) {
    const files = this.args.changeset.get(this.args.payloadKey);
    files?.splice(index, 1);
    this.args.changeset.set(this.args.payloadKey, files);
  }

  /**
   * File upload accepted types.
   * When upload button is clicked and
   * file explorer opens, only those
   * types would be uploadable.
   */
  get acceptedTypes() {
    return this.args.acceptedTypes || ["application/pdf", "image/jpeg", "image/jpg", "image/png", "application/rtf"];
  }
}, _applyDecoratedDescriptor(_class.prototype, "onSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyFile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyFile"), _class.prototype), _class);
export { ChangesetFileUpload as default };